import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names, resolving Tailwind conflicts in favour of the last one.
 *
 * Without the merge step, `cn('p-2', 'p-4')` would emit both and let CSS order
 * decide — which breaks component props that are meant to override a default.
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
